import * as PIXI from 'pixi.js';
import { ParentMixin } from '../core/parentMixin';
import { UpdateFlowMixin } from '../core/updateFlowMixin';
import { SerializableMixin } from '../core/serializableMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
    StringAttribute,
    StringOrNumberAttribute
} from '../core/attributes';
import { Config } from '../video-data/config';

export class DynamicBoxConfigurator extends UpdateFlowMixin(ParentMixin(SerializableMixin(PIXI.utils.EventEmitter))) {
    override _name = 'dynamicBoxConfigurator';
    override _classType = 'DynamicBoxConfigurator';
    readonly graphicType = Config.BOX_GRAPHIC;

    @ColorAttribute()
    private fillColor = 0xFF00FF;
    @AlphaAttribute()
    private fillAlpha = 0.5;
    @ColorAttribute()
    private strokeColor = 0xFF00FF;
    @AlphaAttribute()
    private strokeAlpha = 0.5;
    @NumberAttribute({ animatable: false })
    private strokeWidth = 0;
    @NumberAttribute({ animatable: false })
    private positionX = 0;
    @NumberAttribute({ animatable: false })
    private positionY = 0;
    @StringOrNumberAttribute({ choices: Config.ALL_INFERRED_HEIGHT })
    private boxHeight = 'height';
    @StringOrNumberAttribute({ choices: Config.ALL_INFERRED_WIDTH })
    private boxWidth = 'width';
    @NumberAttribute({ min: 0, animatable: false })
    public topLeftRadius = 0;
    @NumberAttribute({ min: 0, animatable: false })
    public topRightRadius = 0;
    @NumberAttribute({ min: 0, animatable: false })
    public bottomRightRadius = 0;
    @NumberAttribute({ min: 0, animatable: false })
    public bottomLeftRadius = 0;
    @NumberAttribute({ animatable: false })
    private paddingTop = 0;
    @NumberAttribute({ animatable: false })
    private paddingBottom = 0;
    @NumberAttribute({ animatable: false })
    private paddingLeft = 0;
    @NumberAttribute({ animatable: false })
    private paddingRight = 0;
    @StringAttribute({ choices: Config.ALL_ANIMATION_IN_X_DIRECTION })
    private horizontalDirection = Config.RIGHT_ANIMATION_DIRECTION;
    @StringAttribute({ choices: Config.ALL_ANIMATION_IN_Y_DIRECTION })
    private verticalDirection = Config.BOTTOM_ANIMATION_DIRECTION;
    @NumberAttribute()
    private progressYValue = 1;
    @NumberAttribute()
    private progressXValue = 1;

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    /**
     * @inheritDoc
     */
    override get readonlyProperties() {
        return [];
    }

    /**
     * @inheritDoc
     */
    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    };

    override get editableProperties() {
        return super.editableProperties.concat([
            'fillColor',
            'fillAlpha',
            'strokeColor',
            'strokeAlpha',
        ]);
    }
}

